import { render, staticRenderFns } from "./AudienceSelectionCard.vue?vue&type=template&id=0889e141"
import script from "./AudienceSelectionCard.vue?vue&type=script&lang=js"
export * from "./AudienceSelectionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports